/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "giftcard/models.proto" (package "rd.giftcard", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { LedgerEntry } from "../ledger/models_pb";
import { Money } from "../proto/money/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * GiftCard represents a gift card that has been activated.
 * The settings at the time of activation are stored in this message.
 *
 * @generated from protobuf message rd.giftcard.GiftCard
 */
export interface GiftCard {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // required
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID; // required
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp; // db-timestamp
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp; // db-timestamp
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User; // db-user
    /**
     * @generated from protobuf field: rd.user.User updated_by = 6
     */
    updatedBy?: User; // db-user
    /**
     * @generated from protobuf field: string encrypted_card_number = 7
     */
    encryptedCardNumber: string; // actually a hash
    /**
     * @generated from protobuf field: string card_number_last_4 = 8
     */
    cardNumberLast4: string;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard.Type type = 9
     */
    type: GiftCard_Type;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard.Status status = 10
     */
    status: GiftCard_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp activated_at = 11
     */
    activatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deactivated_at = 12
     */
    deactivatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 13
     */
    productId?: UUID;
}
/**
 * @generated from protobuf enum rd.giftcard.GiftCard.Type
 */
export enum GiftCard_Type {
    /**
     * should never be used
     *
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * TODO: add TYPE_VIRTUAL
     *
     * @generated from protobuf enum value: TYPE_PHYSICAL = 1;
     */
    PHYSICAL = 1
}
/**
 * @generated from protobuf enum rd.giftcard.GiftCard.Status
 */
export enum GiftCard_Status {
    /**
     * CREATED -> ACTIVE -> DEACTIVATED
     *
     * should never be used
     *
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * pending activation
     *
     * @generated from protobuf enum value: STATUS_CREATED = 1;
     */
    CREATED = 1,
    /**
     * active and ready to be used
     *
     * @generated from protobuf enum value: STATUS_ACTIVE = 2;
     */
    ACTIVE = 2,
    /**
     * deactivated and no longer usable
     *
     * @generated from protobuf enum value: STATUS_DEACTIVATED = 3;
     */
    DEACTIVATED = 3
}
/**
 * GiftCardBalance represents the balance of a gift card.
 * This message is used to track the every-changing balance of a gift card over time.
 *
 * @generated from protobuf message rd.giftcard.GiftCardBalance
 */
export interface GiftCardBalance {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // same as gift card id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID; // required
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp; // db-timestamp
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp; // db-timestamp
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User; // db-user
    /**
     * @generated from protobuf field: rd.user.User updated_by = 6
     */
    updatedBy?: User; // db-user
    /**
     * @generated from protobuf field: rd.proto.money.Money balance = 7
     */
    balance?: Money; // current balance of the gift card
}
/**
 * @generated from protobuf message rd.giftcard.GiftCardActivity
 */
export interface GiftCardActivity {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money net_amount = 3
     */
    netAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money running_balance = 4
     */
    runningBalance?: Money;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCardActivity.Type type = 5
     */
    type: GiftCardActivity_Type;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry ledger_entry = 6
     */
    ledgerEntry?: LedgerEntry;
}
/**
 * @generated from protobuf enum rd.giftcard.GiftCardActivity.Type
 */
export enum GiftCardActivity_Type {
    /**
     * should never be used
     *
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_ACTIVATION = 1;
     */
    ACTIVATION = 1,
    /**
     * @generated from protobuf enum value: TYPE_REDEMPTION = 2;
     */
    REDEMPTION = 2,
    /**
     * @generated from protobuf enum value: TYPE_REFUND = 3;
     */
    REFUND = 3,
    /**
     * @generated from protobuf enum value: TYPE_DEACTIVATION = 4;
     */
    DEACTIVATION = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class GiftCard$Type extends MessageType<GiftCard> {
    constructor() {
        super("rd.giftcard.GiftCard", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 6, name: "updated_by", kind: "message", T: () => User },
            { no: 7, name: "encrypted_card_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "card_number_last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "type", kind: "enum", T: () => ["rd.giftcard.GiftCard.Type", GiftCard_Type, "TYPE_"] },
            { no: 10, name: "status", kind: "enum", T: () => ["rd.giftcard.GiftCard.Status", GiftCard_Status, "STATUS_"] },
            { no: 11, name: "activated_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "deactivated_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "product_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GiftCard>): GiftCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptedCardNumber = "";
        message.cardNumberLast4 = "";
        message.type = 0;
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<GiftCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftCard): GiftCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 6:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* string encrypted_card_number */ 7:
                    message.encryptedCardNumber = reader.string();
                    break;
                case /* string card_number_last_4 */ 8:
                    message.cardNumberLast4 = reader.string();
                    break;
                case /* rd.giftcard.GiftCard.Type type */ 9:
                    message.type = reader.int32();
                    break;
                case /* rd.giftcard.GiftCard.Status status */ 10:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp activated_at */ 11:
                    message.activatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.activatedAt);
                    break;
                case /* google.protobuf.Timestamp deactivated_at */ 12:
                    message.deactivatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deactivatedAt);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 13:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 6; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string encrypted_card_number = 7; */
        if (message.encryptedCardNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.encryptedCardNumber);
        /* string card_number_last_4 = 8; */
        if (message.cardNumberLast4 !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cardNumberLast4);
        /* rd.giftcard.GiftCard.Type type = 9; */
        if (message.type !== 0)
            writer.tag(9, WireType.Varint).int32(message.type);
        /* rd.giftcard.GiftCard.Status status = 10; */
        if (message.status !== 0)
            writer.tag(10, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp activated_at = 11; */
        if (message.activatedAt)
            Timestamp.internalBinaryWrite(message.activatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deactivated_at = 12; */
        if (message.deactivatedAt)
            Timestamp.internalBinaryWrite(message.deactivatedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 13; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.giftcard.GiftCard
 */
export const GiftCard = new GiftCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GiftCardBalance$Type extends MessageType<GiftCardBalance> {
    constructor() {
        super("rd.giftcard.GiftCardBalance", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 6, name: "updated_by", kind: "message", T: () => User },
            { no: 7, name: "balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<GiftCardBalance>): GiftCardBalance {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GiftCardBalance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftCardBalance): GiftCardBalance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 6:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.money.Money balance */ 7:
                    message.balance = Money.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftCardBalance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 6; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money balance = 7; */
        if (message.balance)
            Money.internalBinaryWrite(message.balance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.giftcard.GiftCardBalance
 */
export const GiftCardBalance = new GiftCardBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GiftCardActivity$Type extends MessageType<GiftCardActivity> {
    constructor() {
        super("rd.giftcard.GiftCardActivity", [
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "net_amount", kind: "message", T: () => Money },
            { no: 4, name: "running_balance", kind: "message", T: () => Money },
            { no: 5, name: "type", kind: "enum", T: () => ["rd.giftcard.GiftCardActivity.Type", GiftCardActivity_Type, "TYPE_"] },
            { no: 6, name: "ledger_entry", kind: "message", T: () => LedgerEntry }
        ]);
    }
    create(value?: PartialMessage<GiftCardActivity>): GiftCardActivity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<GiftCardActivity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftCardActivity): GiftCardActivity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* rd.proto.money.Money net_amount */ 3:
                    message.netAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.netAmount);
                    break;
                case /* rd.proto.money.Money running_balance */ 4:
                    message.runningBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.runningBalance);
                    break;
                case /* rd.giftcard.GiftCardActivity.Type type */ 5:
                    message.type = reader.int32();
                    break;
                case /* rd.ledger.LedgerEntry ledger_entry */ 6:
                    message.ledgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntry);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftCardActivity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money net_amount = 3; */
        if (message.netAmount)
            Money.internalBinaryWrite(message.netAmount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money running_balance = 4; */
        if (message.runningBalance)
            Money.internalBinaryWrite(message.runningBalance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCardActivity.Type type = 5; */
        if (message.type !== 0)
            writer.tag(5, WireType.Varint).int32(message.type);
        /* rd.ledger.LedgerEntry ledger_entry = 6; */
        if (message.ledgerEntry)
            LedgerEntry.internalBinaryWrite(message.ledgerEntry, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.giftcard.GiftCardActivity
 */
export const GiftCardActivity = new GiftCardActivity$Type();
